import isEmpty from 'lodash/isEmpty';
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import IconInfo from '@spothero/icons/info';
import TextButton from '@spothero/ui/text-button';
import {DESTINATION_DATA} from 'destination/destination-prop-types';
import CitySchema from 'city/CitySchema';
import DestinationSchema from 'destination/DestinationSchema';

const SpotListHeading = ({
    isMonthly,
    city,
    destination,
    searchType,
    title,
    displayTitle,
    showEventsLink,
    description,
    shortDescription,
    onShowInfoClick,
    onToggleEventList,
}) => {
    const isVenue = searchType === 'venue';

    return (
        <div
            className="SpotListHeading"
            itemScope
            itemType="http://schema.org/Place"
        >
            <h1>
                <span>{displayTitle}</span>
                <meta itemProp="name" content={title} />
                {description && (
                    <TextButton
                        className="SpotListHeading-info-link"
                        onClick={onShowInfoClick}
                    >
                        <IconInfo />
                    </TextButton>
                )}
            </h1>
            {!isEmpty(shortDescription) && (
                <p className="SpotListHeading-short-description">
                    {shortDescription}
                </p>
            )}
            {showEventsLink && !isMonthly && isVenue && (
                <TextButton
                    className="SpotListHeading-events-link"
                    onClick={onToggleEventList}
                >
                    View Upcoming Events
                </TextButton>
            )}
            {searchType === 'city' && <CitySchema city={city} />}
            {(searchType === 'destination' || isVenue) && (
                <DestinationSchema destination={destination} city={city} />
            )}
        </div>
    );
};

SpotListHeading.propTypes = {
    isMonthly: PropTypes.bool.isRequired,
    city: PropTypes.object.isRequired,
    destination: PropTypes.shape(DESTINATION_DATA),
    searchType: PropTypes.string,
    title: PropTypes.string,
    displayTitle: PropTypes.string,
    showEventsLink: PropTypes.bool,
    description: PropTypes.string,
    shortDescription: PropTypes.string,
    onShowInfoClick: PropTypes.func.isRequired,
    onToggleEventList: PropTypes.func,
};

const mapStateToProps = ({
    city: {data: city},
    destination: {data: destination},
    search: {
        data: {searchType},
    },
    searchRequest: {monthly: isMonthly},
}) => {
    let newTitle = null;
    let displayTitle = null;
    let newDescription = null;
    let newShortDescription = null;

    if (searchType === 'city') {
        const {
            display_name: title,
            description,
            short_description: shortDescription,
        } = city;

        newTitle = unescape(title);
        displayTitle = `${newTitle} ${isMonthly ? 'Monthly ' : ''}Parking`;
        newDescription = description;
        newShortDescription = shortDescription;
    } else if (searchType === 'destination' || searchType === 'venue') {
        const {
            title,
            description,
            short_description: shortDescription,
        } = destination;

        newTitle = unescape(title);
        displayTitle = `${newTitle} ${isMonthly ? 'Monthly ' : ''}Parking`;
        newDescription = description;
        newShortDescription = shortDescription;
    }

    return {
        isMonthly,
        city,
        destination,
        searchType,
        title: newTitle,
        displayTitle,
        description: newDescription,
        shortDescription: newShortDescription,
    };
};

export default connect(mapStateToProps)(SpotListHeading);
